import {gql, useLazyQuery} from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const QUERY = gql`
query getApartmentShowMore($apartmentShowMoreId: String!, $locale: String!){
    resortApartmentCategory(id: $apartmentShowMoreId, locale: $locale){
        spaceForABabybed,
        numberOfBathrooms,

        apartmentCategoryAccessibilityCollection{
            items{
                title
            }
        },

        apartmentCategoryKitchenCollection{
            items{
            ... on ApartmentCategoryKitchenEntry {
                        title
                    }
            }
        },

        apartmentCategoryOutdoorCollection{
            items{
                title
            }
        },

        apartmentCategoryBathroomCollection{
            items{
                title
            }
        },

        apartmentCategoryBathroomCollection{
            items{
                title
            }
        },
        apartmentCategorySleepingArrangementsCollection{
            items{
                title
            }
        },
        accessibilityHint
    }
}`;

export const useApartmentShowMore = () => {
    const {logger} = useLogger();
    const [getApartmentShowMore, { loading, data, error }] = useLazyQuery(QUERY, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    let apartmentShowMore = undefined;
    if (data) {
        apartmentShowMore = data.resortApartmentCategory;
    }

    if (error?.message) {
        logger(error?.message, "error", "useApartmentShowMore", error?.stack);
    }

    return {
        apartmentShowMore,
        apartmentShowMoreLoading: loading,
        getApartmentShowMore
    };
};
